import styled, { css } from 'styled-components';

export const ScrollContainer = styled.div<{ $scrollAuto: boolean }>`
  ${({ $scrollAuto }) =>
    $scrollAuto &&
    css`
      height: 100%;
      overflow: auto;
    `};
`;
